import React from 'react';
import { Box, Typography } from '@mui/material';
import { getRemainingDaysInfo } from '../../utils/dateUtils';

interface ElapsedDaysDisplayProps {
  startDate: string | null | undefined;
  endDate: string | null | undefined;
  status: string;
}

const ElapsedDaysDisplay: React.FC<ElapsedDaysDisplayProps> = ({ startDate, endDate, status }) => {
  // 経過日数の計算
  const getElapsedDays = (startAt: string | null | undefined) => {
    // データがない場合は0を返す
    if (!startAt) return 0;
    try {
      // 目標: YYYY-MM-DD形式に正規化する
      let dateValue;
      // 日付文字列を正規化
      if (typeof startAt === 'string') {
        // DBから返される日付形式に対応
        const matched = startAt.match(/^(\d{4}-\d{2}-\d{2})/);
        if (matched) {
          // YYYY-MM-DD部分を抽出
          dateValue = matched[1];
        } else {
          console.warn('日付形式を認識できません:', startAt);
          return 0;
        }
      } else {
        console.warn('日付が文字列ではありません:', startAt);
        return 0;
      }
      // 日付部分のみで新たなDateオブジェクトを作成
      const [ year, month, day ] = dateValue.split('-').map(Number);
      const startDate = new Date(year, month - 1, day); // 月は0から始まるため-1
      // 今日の日付（時間なし）
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      // 差分を計算（ミリ秒）
      const diffMs = today.getTime() - startDate.getTime();
      // ミリ秒を日数に変換
      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      return days > 0 ? days : 0;
    } catch (error) {
      console.error('日付計算エラー:', error);
      return 0;
    }
  };
  if (status === 'DOING' && startDate) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
        <Typography
          sx={{
            fontWeight: 'bold',
            color: '#3949ab',
            fontSize: '0.85rem'
          }}
        >
          {getElapsedDays(startDate)}日目
        </Typography>

        {/* 残り日数の表示 */}
        {endDate && (
          (() => {
            const remainingInfo = getRemainingDaysInfo(endDate);
            if (remainingInfo.status === '残り' && remainingInfo.days !== null) {
              // 残り日数がある場合
              return (
                <Typography
                  sx={{
                    fontSize: '0.8rem',
                    color: 'text.primary'
                  }}
                >
                  ( 残り: {remainingInfo.days}日 )
                </Typography>
              );
            } else if (remainingInfo.status === '最終日') {
              // 今日が最終日の場合
              return (
                <Typography
                  sx={{
                    fontSize: '0.8rem',
                    fontWeight: 'bold',
                    color: 'text.primary'
                  }}
                >
                  ( 最終日 )
                </Typography>
              );
            } else if (remainingInfo.status === '終了') {
              // 終了日を過ぎている場合
              return (
                <Typography
                  sx={{
                    fontSize: '0.8rem',
                    color: 'text.primary'
                  }}
                >
                  ( 終了 )
                </Typography>
              );
            } else {
              return null;
            }
          })()
        )}
      </Box>
    );
  }
  return (
    <Typography variant="body2" color="text.secondary">
      -
    </Typography>
  );
};
export default ElapsedDaysDisplay;
